export const enum LoanAction {
  REJECT = 'REJECT',
  APPROVE = 'APPROVE',
  DISBURSE = 'DISBURSE',
  COUNTER = 'COUNTER',
}

export interface LoanActionPayload {
  action: LoanAction | string;
  comment?: string;
  amount?: number;
  tenure?: number;
}

export interface Loan {
  created_at: string | number | Date;
  member: any;
  institution: any; // string or { name: string; ... }
  principal_amount: string | number;
  id?: string;
  reference?: string;
  amount?: number;
  interest?: number;
  totalRepayment?: number;
  monthlyRepayment?: number;
  totalAmountPaid?: number;
  receivableAmount?: number;
  processingFee?: string | number;
  processingFeeRate?: string | number;
  interestRate?: string | number;
  repaymentDate?: Date;
  tenure?: number;
  narration?: string;
  status?: string;
  disbursedAt?: string | Date | null;
  disbursementId?: string;
  createdAt?: Date;
  userMonthlyIncome: number;
  userGhanaCard?: string;
  user: User | null;
  product?: {
    id: string;
    name: string;
    processingFee?: number;
    tenureType?: string;
  };
  counterOffer?: CounterOffer | null;
  documents?: string[];
  guarantors?: LoanGuarantor[];
  requiresAcceptance?: boolean;
}

export interface LoanGuarantor {
  id: string;
  name: string;
  phone: string;
  workPlace: string;
  workRole: string;
  relationship: string;
  netSalary: number;
  ghanaCardNumber: string;
  digitalAddress: string;
  ghanaCardImage: string | null;
  image: string | null;
  signature: string | null;
  token: string;
}

export interface GroupedGuarantor {
  token: string;
  applicant: LoanGuarantor;
  guarantor: LoanGuarantor | null;
}

export interface CounterOffer {
  id: string;
  amount: number;
  interest: number;
  totalRepayment: number;
  tenure: string | number;
  repaymentDate: string | Date;
  type: string;
  createdAt: string | Date;
  receivableAmount?: string | number;
  processingFee?: string | number;
}

export interface User {
  createdAt?: Date | string;
  email?: string;
  firstName: string;
  lastName: string;
  id: string;
  mobileNumber: string;
  otherName?: string | null;
  ghanaCardNumber?: string;
  isGhanaCardVerified?: boolean;
  gender?: string | null;
  userImage?: string | null;
  kyc?: {
    occupation?: string;
    address?: string;
    validFrom?: string;
    validTo?: string;
    refNumber?: string;
  } | null;
  documents?: string[];
  account?: any;
}

export interface LoanQueryParams {
  institutionId?: string;
  productId?: string;
  paginate?: boolean;
  perPage?: number;
  page?: number;
  keyword?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
  minAmount?: number;
  maxAmount?: number;
}

export interface ProductLoanDashboard {
  productName: string;
  totalApplications: number;
  totalRepaymentDue: number;
  totalDenied: number;
}

export type LoanRepaymentType = 'BANK' | 'CASH' | 'MOMO';

export interface LoanRepaymentDto {
  id: string;
  transactionId: string;
  type?: LoanRepaymentType;
  amount: string | number;
  date: string;
  comment?: string;
  loan: Loan;
  createdAt: string;
}

export interface CreateLoanRepaymentDto {
  loanId: string;
  type: LoanRepaymentType;
  transactionId: string;
  amount: number;
  date: string;
  comment?: string;
}

export type DataImportStatus = 'PROCESSING' | 'COMPLETED' | 'PARTIAL' | 'FAILED';

export interface DataImportRowError {
  row: number;
  reference: string | null;
  error: string;
}

export interface DataImport {
  id: string;
  path: string;
  type: string;
  status: DataImportStatus;
  total: number;
  success: number;
  failed: number;
  rowErrors: DataImportRowError[] | null;
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UploadRepaymentsResponse {
  id: string;
  message: string;
}

export interface LoanRepaymentQueryParams {
  perPage?: number;
  paginate?: boolean;
  page?: number;
  keyword?: string;
  loanId?: string;
  productId?: string;
  startDate?: string;
  endDate?: string;
}
